import React from "react";
import {ClaimInterface} from "../Interface/ClaimInterface";
import {ClaimModel} from "../model/ClaimModel";
import {ProviderInterface} from "../Interface/ProviderInterface";
import {ProviderModel} from "../model/ProviderModel";
import {ClaimStateInterface} from "../Interface/ClaimStateInterface";

export interface ClaimDetailContextInterface {
    claim: ClaimInterface
    provider: ProviderInterface
    statuses: ClaimStateInterface[]
    customerCode: string
    onRatingSuccess: () => void
    onArchiveSuccess: () => void
}

export const ClaimDetailContext = React.createContext<ClaimDetailContextInterface>({
    claim: ClaimModel,
    customerCode: "",
    provider: ProviderModel,
    statuses: [],
    onRatingSuccess: () => {},
    onArchiveSuccess: () => {}
})
